<template>
  <div id="app">
    <header class="main-header">
      <div class="header-content">
        <div class="header-logo" @click="$router.push('/')">
          <v-avatar size="40" class="logo-avatar">
            <v-img src="/favicon.png"></v-img>
          </v-avatar>
          <span class="logo-text hidden-xs">Roster Pal</span>
        </div>
        <nav class="header-nav">
          <router-link to="/">Home</router-link>
          <router-link to="/personal">Personal</router-link>
          <router-link to="/team">Team</router-link>
        </nav>
        <div class="header-spacer hidden-xs"></div>
      </div>
    </header>
    <PWAInstallPrompt />
    <div class="content">
      <router-view></router-view>
    </div>
    <footer>
      <p>&copy;  2026 Roster Pal. All rights reserved.</p>
    </footer>
  </div>
</template>

<script>

import PWAInstallPrompt from "./components/PWAInstallPrompt.vue";

export default {
  components: {
    PWAInstallPrompt
  },
  methods: {
  }
};
</script>

<style scoped>
html,
body {
  height: 100%;
  margin: 0;
  font-family: 'Rubik', sans-serif;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  display: flex;
  flex-direction: column;
  background-color: #f8f4ff;
  color: #333;
}

#app {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.content {
  flex: 1;
  padding-bottom: 100px;
  padding-top: 80px;
}

.main-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 70px;
  background-color: rgba(106, 51, 153, 0.95); /* New purple with slight transparency */
  backdrop-filter: blur(10px);
  color: white;
  z-index: 1000;
  box-shadow: 0 2px 15px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
}

.header-content {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-logo {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.2s;
}

.header-logo:hover {
  opacity: 0.8;
}

.logo-avatar {
  border: 0px solid rgba(255,255,255,0.8);
  margin-right: 12px;
}

.logo-text {
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.header-nav {
  display: flex;
  gap: 8px;
}

.header-nav a {
  color: white;
  padding: 8px 16px;
  text-decoration: none;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.3s ease;
  font-size: 0.95rem;
}

.header-nav a:hover {
  background-color: rgba(255,255,255,0.15);
}

.header-nav a.router-link-exact-active {
  background-color: rgba(255,255,255,0.2);
  font-weight: 700;
}

.header-spacer {
  width: 150px; /* To balance the logo on the other side */
}

@media (max-width: 600px) {
  .main-header {
    height: 60px;
  }
  .header-content {
    padding: 0 16px;
  }
  .logo-text, .header-spacer {
    display: none;
  }
}

footer {
  text-align: center;
  padding: 1rem;
  background-color: #1a0a2a;
  color: white;
  position: fixed;
  /* Change to fixed */
  bottom: 0;
  /* Stick to bottom */
  left: 0;
  /* Align to left */
  right: 0;
  /* Align to right */
  width: 100%;
  /* Full width */
  z-index: 1000;
  /* Ensure it's above other content */
}
</style>
